<template>
  <div v-on:click="toggleElevation" class="chart-info p-1 d-flex justify-content-center">
    <small class="text-center">
      <strong>Elevation profile</strong>
      <span class=" d-none d-md-inline">: Hover/tap elevation line to track a specific point on the map.</span>
      <span class="ml-3" style="color: #af8e0e;"><strong id="toggleShow">{{ toggleText }}</strong></span>
    </small>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  data() {
    return {
      show: true,
    };
  },
  props: {
    initialShow: { type: Boolean, required: false, default: true },
  },
  methods: {
    toggleElevation() {
      this.show = !this.show;
      this.setElevationHeight()
    },
    setElevationHeight() {
      if(this.show) {
        this.element!.style.height = '150px';
      } else {
        this.element!.style.height = '0px';
      }
    }
  },

  computed: {
    toggleText() {
      return this.show ? 'HIDE' : 'SHOW';
    },

    element() {
      return document.getElementById('line-chart')
    }
  },

  created() {
    this.show = this.initialShow;
  },

  mounted() {
    this.setElevationHeight()
  },
});
</script>
